
import Hero from "../../components/Banner/Hero";

type Props = {};

const Activities = (props: Props) => {
  return (
    <div>
      <Hero />
      
    </div>
  );
};

export default Activities;
